module.exports = __webpack_public_path__ + "img/logo7@2x.bf8a8b9a.png";